import AuthGuard from '@/guard/auth'
import Navbar from '@/components/menu/Navbar'
import IamGuard from '@/guard/iam'
import SettingsPage from '@/components/pages/SettingsPage'

function Settings() {

	return (
		<AuthGuard>
			<IamGuard>
				<div className='relative min-h-screen flex flex-col'>
					<Navbar></Navbar>
					<SettingsPage />
				</div>
			</IamGuard>
		</AuthGuard>
	)
}

export default Settings
